import React from 'react';
import { GridColDef, GridValueGetterParams } from "@mui/x-data-grid";

const defaultProps = { sortable: false, flex: 1, minWidth: 80, maxWidth: 80, };

export const ProceduresTableColumns = (): GridColDef[] => [
  { field: 'id' },
  { ...defaultProps, field: 'tooth', headerName: 'Tooth #', minWidth: 80, maxWidth: 80 },
  { field: 'code', headerName: 'Code', ...defaultProps },
  { ...defaultProps, field: 'description', headerName: 'Description', minWidth: 140, maxWidth: 400 },
  {
    field: 'amountBilled', headerName: '', ...defaultProps,
    valueGetter: (params: GridValueGetterParams) => `$${Math.round(params?.value)}`
  },
];